import React, {Fragment} from 'react'
import { BrowserRouter,  Route,Switch } from 'react-router-dom'
import CookieConsent from "react-cookie-consent";
import Context from './Context'
import './App.css';
import {Home} from './pages/home'
import { positions, Provider } from "react-alert";
import AlertMUITemplate from "react-alert-template-mui";
import {Homeregistrado} from './pages/homeRegistrado'
import {Subhomefiltro} from './pages/subhomefiltro'
import { Evento } from './pages/evento';
import { EventoBajoDemanda } from './pages/eventobajodemanda';
import { Registro } from './pages/registro';
import { Recuperapass } from './pages/recuperapass';
import { Activarcuenta } from './pages/activarcuenta';
import { Perfilusuario } from './pages/perfilusuario';
import { Sectores } from './pages/sectores';
import { Politicadecookies } from './pages/politicadecookies';
import { Politicadeprivacidad } from './pages/politicadeprivacidad';
import { EditaPerfilusuario } from './pages/editaperfilusuario';
import { Avisolegal } from './pages/avisolegal';
import { Contacto } from './pages/contacto';
import { Login } from './pages/login';
import { Standvirtual } from './pages/standvirtual';
import { Standvirtualpublico } from './pages/standvirtualpublico';
import { Moderacion } from './components/Moderacion';
const options = {
  timeout: 5000,
  position: positions.MIDDLE
};

export const App = (props) => {


  return  <BrowserRouter basename={process.env.REACT_APP_EVENT_PATH}  preserverScrollPosition={false}>
    <Context.Consumer> 
      {
        ({isAuth,activateAuth,modaToggle,modaIsOpen,removeAuth,logEvento,}) =>
          isAuth ?
            <Fragment>
            <Provider template={AlertMUITemplate} {...options}>
            <Switch>
              <Route path='/' exact  render={() => (<Home  activateAuth={activateAuth} removeAuth={removeAuth} logEvento={logEvento}  /> )} />
              <Route path='/categoria/:id' exact  render={() => (<Sectores isAuth={isAuth}  activateAuth={activateAuth} removeAuth={removeAuth}  /> )} />
              <Route path='/etiqueta/:id' exact  render={() => (<Subhomefiltro isAuth={isAuth}  activateAuth={activateAuth} removeAuth={removeAuth}  /> )} />
              <Route path='/evento/:id' exact  render={() => (<Evento isAuth={isAuth}  activateAuth={activateAuth} modaToggle={modaToggle} modaIsOpen={modaIsOpen} removeAuth={removeAuth} logEvento={logEvento} /> )} />
              <Route path='/registro' exact  render={() => (<Registro activateAuth={activateAuth}  removeAuth={removeAuth} /> )} />
              <Route path='/standvirtual/:id/:idEvento' exact  render={() => (<Standvirtual isAuth={isAuth}  activateAuth={activateAuth} modaToggle={modaToggle} modaIsOpen={modaIsOpen} removeAuth={removeAuth} logEvento={logEvento} /> )} />
              <Route path='/recuperarcuenta' exact  render={() => (<Recuperapass activateAuth={activateAuth}  removeAuth={removeAuth} /> )} />
              <Route path='/activarcuenta' exact  render={() => (<Activarcuenta  activateAuth={activateAuth}  removeAuth={removeAuth} /> )} />
              <Route path='/perfilusuario/:id' exact  render={() => (<Perfilusuario  activateAuth={activateAuth}  removeAuth={removeAuth} /> )} />
              <Route path='/editarperfil/' exact  render={() => (<EditaPerfilusuario  activateAuth={activateAuth}  removeAuth={removeAuth} /> )} />
              <Route path='/politicadecookies/' exact  render={() => (<Politicadecookies  activateAuth={activateAuth}  removeAuth={removeAuth} /> )} />
              <Route path='/politicadeprivacidad/' exact  render={() => (<Politicadeprivacidad  activateAuth={activateAuth}  removeAuth={removeAuth} /> )} />
              <Route path='/avisolegal/' exact  render={() => (<Avisolegal  activateAuth={activateAuth}  removeAuth={removeAuth} /> )} />
              <Route path='/contacto/' exact  render={() => (<Contacto  activateAuth={activateAuth}  removeAuth={removeAuth} /> )} />
              <Route path='/moderacion/' exact  render={() => (<Moderacion  activateAuth={activateAuth}  removeAuth={removeAuth} /> )} />
            </Switch>
            </Provider>
            </Fragment>
          :
          <Fragment>
          <Provider template={AlertMUITemplate} {...options}>  
          <Switch>
            <Route path='/evento/bajodemanda/:idEvento/:idUsuario' exact  render={() => (<EventoBajoDemanda isAuth={isAuth}  activateAuth={activateAuth} modaToggle={modaToggle} modaIsOpen={modaIsOpen} removeAuth={removeAuth} logEvento={logEvento} /> )} />
            <Route path='/standvirtual/:id/:idEvento/:idUsuario' exact  render={() => (<Standvirtualpublico isAuth={isAuth}  activateAuth={activateAuth} modaToggle={modaToggle} modaIsOpen={modaIsOpen} removeAuth={removeAuth} logEvento={logEvento} /> )} />
            <Route path='/moderacion/' exact  render={() => (<Moderacion  activateAuth={activateAuth}  removeAuth={removeAuth} /> )} />
            <Route path='/'   render={() => (<Login  activateAuth={activateAuth} removeAuth={removeAuth} logEvento={logEvento} /> )} />
          </Switch>
          </Provider>
          <CookieConsent
            location="bottom"
            buttonText="Aceptar"
            cookieName="upta-cookie-consent"
            style={{ background: "#2B373B" }}
            buttonStyle={{background: "#42A72C", color: "#fff", fontSize: "16px", padding: "15px 40px", margin:"15px 30px" }}
            expires={150}
          >
            <div className="avisoCookies">
              <p>Utilizamos Cookies propias y de terceros para mejorar su experiencia como usuario y 
                captar datos estadísticos. <br/>
                Para seguir navegando acepte el uso de cookies. Consulte la <a href="https://upta.es/politica-de-datos/" target="_blank">Política de Privacidad</a></p>
              <ul className="option-list">
                <li>
                  <span className="option">
                    <input id="option-ESSENTIAL" type="checkbox" checked disabled />
                    <label for="option-ESSENTIAL"></label>
                  </span>
                  <label className="option-label option-1">Estrictamente necesario</label>
                </li>
                <li>
                  <span className="option">
                    <input id="option-ANALYTICS" type="checkbox" checked disabled />
                    <label for="option-ANALYTICS"></label>
                  </span>
                  <label className="option-label option-4">Anal&iacute;tica</label>
                </li>
              </ul>
            </div>
          </CookieConsent>
          </Fragment>
      }
    </Context.Consumer>
    </BrowserRouter>
}